import { createReducer } from '@reduxjs/toolkit'

import {
  clientSettingsReducerConfig,
  initialClientSettingsState,
} from '@gocanvas/client/dist/store/reducers/clientSettings'

export const clientSettingsReducer = createReducer(
  {
    ...initialClientSettingsState,
    clientType: 'webform',
    formMode: 'live',
    undoEnabled: false,
  },
  clientSettingsReducerConfig
)
